import { render, staticRenderFns } from "./PreviewType.vue?vue&type=template&id=2b244801&"
import script from "./PreviewType.vue?vue&type=script&lang=ts&"
export * from "./PreviewType.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports